<div id="galleria">
  <p-galleria
    #galleria
    [responsiveOptions]="responsiveOptions"
    [(value)]="images"
    [(activeIndex)]="activeIndex" [numVisible]="5" [containerStyle]="{'max-width':'1100px', 'margin': 'auto', 'height': 'auto'}" [containerClass]="galleriaClass()" [showThumbnails]="false"
    [showItemNavigators]="true" [showIndicators]="true" [showItemNavigatorsOnHover]="true" [circular]="true" [autoPlay]="true" [transitionInterval]="5000">
    <ng-template #item let-item>
      <img [src]="item.galleryImages" [ngStyle]="{'width': !fullscreen ? '100%' : '', 'display': !fullscreen ? 'block' : '', 'max-height' : fullscreen ? '' : '41rem'}"/>
    </ng-template>
    <ng-template #thumbnail let-item>
      <div class="p-grid p-nogutter p-justify-center">
        <img [src]="item.galleryImages" style="display: block;"/>
      </div>
    </ng-template>
  </p-galleria>
</div>
